import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from "components/CustomButtons/Button.js";
import { colors } from '../components/Theme/WebTheme';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {
  Typography,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  heading:{
    marginBottom:20
  },
  submit:{
    backgroundColor:'#379ab2',
    width:'90%'
  },
  submit1:{
    backgroundColor:'White',
    color:'#4c63b8'
    },
  notchedOutline:{
    borderColor:colors.Rigzie1,
    width:'90%',
  },
  notchedOutline1:{
    borderColor:colors.Rigzie1,
    width:'80%',
  },
  carphotoRtl:{
    height: '16px',
    marginLeft:'10px'
  },
  carphoto: {
    height: '18px',
    marginRight: '10px'
  },
  input:{
    width:'90%',
    borderColor:colors.Rigzie1,
  }
}));

export default function AddRider() {

const [data, setData] = useState({
    firstName: '',
    lastName: '',
    mobile: '',
    email: '',
    signupViaReferral: ''
});


const { t,i18n } = useTranslation();
const isRTL = i18n.dir();
const classes = useStyles();
const {
    addUser,
    checkUserExists
} = api;
const history = useHistory();
const dispatch = useDispatch();
const auth = useSelector(state => state.auth);
const handleTextChange = (e) => {
  setData({ ...data, [e.target.name]: e.target.value });
};
const goBack=()=>{
  history.goBack();
}

const submitValue = () => {
        let arr = {
            firstName: data.firstName,
            lastName: data.lastName,
            mobile: data.mobile,
            email: data.email,
        };

        checkUserExists(arr).then((res) => {
            if (res.users && res.users.length > 0) {
              alert(t('user_exists'));
            }
            else if(res.error){
              alert(t('email_or_mobile_issue'));
            }
            else{
              if(data.firstName.length > 0 && data.lastName.length > 0 && data.email.length > 0){
                if(auth && auth.info && auth.info.profile && auth.info.profile.usertype === 'admin'){
                arr.createdByAdmin = true;
                }else{
                  arr.createdBycorporateAdmin = true;
                  arr.corporateAdminId = auth && auth.info? auth.info.uid:'';
                  arr.createdByAdmin = true;
                }
                arr.usertype = 'rider';
                arr.createdAt = new Date().toISOString();
                arr.referralId= data.firstName.toLowerCase() + Math.floor(1000 + Math.random() * 9000).toString();
                arr.signupViaReferral = data.signupViaReferral;
                arr.walletBalance = 0;
                arr.approved = true;
                dispatch(addUser(arr));
                alert('User Successfully Created');
                setData({
                      firstName: '',
                      lastName: '',
                      mobile: '',
                      email: '',
                      signupViaReferral: '',
                  });
              }else{
                alert('Please FillUp Properly!')
              }
            }
        });
  }

  return (
    // data.loading ? <CircularLoading /> :
    <div>
    <div className={classes.heading}>
    <Typography component="h1" variant="h5" style={{ marginTop: '8px',fontWeight:'bolder',color:colors.Rigzie1,textDecoration:'underline'}}>
    {t('add_new_rider')}
          </Typography>
          </div>
          <Button
                type="back"
                 width='3%'
                 variant="contained"
                 className={classes.submit1}
                 startIcon={<KeyboardBackspaceIcon icon={KeyboardBackspaceIcon} />}
                 onClick={()=>goBack()}
               >
                  {t('go_back')}
               </Button>

               <Box boxShadow={6}
       
       m={2}
       p={2} style={{borderRadius:20,border: '2px solid #109496',width:'60%',height:'90%'}}>
     <CardContent>
      <Grid container style={{direction:isRTL ==='rtl'?'rtl':'ltr'}} >
          <Grid item xs={12} sm={12} md={6} lg={6}>
          <Grid container spacing={2}>
          <Grid item xs={6}>
          <Typography component="h1" variant="h6">
              {t('first_name')}
            </Typography>
            <TextField
            className={isRTL ==="rtl"? classes.rootRtl:null}
              variant="outlined"
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline1
                }
              }}
              margin="normal"
              required
              fullWidth
              id="firstName"
               label={t('first_name')}
               name="firstName"
              autoComplete="firstName"
              onChange={handleTextChange}
              defaultValue={data.firstName}
            />
            </Grid>
        <Grid item xs={6}>
        <Typography component="h1" variant="h6">
              {t('last_name')}
            </Typography>
             <TextField
              className={isRTL ==="rtl"? classes.rootRtl:null}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline1
                }
              }}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="lastName"
              label={t('last_name')}
              name="lastName"
              autoComplete="lastName"
              onChange={handleTextChange}
              defaultValue={data.lastName}
            />
            </Grid>
            </Grid>
            <Typography component="h1" variant="h6">
              {t('mobile')}
            </Typography>
            <TextField
              className={isRTL ==="rtl"? classes.rootRtl:null}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline
                }
              }}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="mobile"
              label={t('mobile')}
              name="mobile"
              autoComplete="mobile"
              onChange={handleTextChange}
              defaultValue={data.mobile}
            />
   </Grid>
    <Grid item xs={12} sm={12} md={6} lg={6}>
    <Typography component="h1" variant="h6">
              {t('email')}
            </Typography>
            <TextField
              className={isRTL ==="rtl"? classes.rootRtl:null}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline
                }
              }}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="email"
              label= {t('email')}
              name="email"
              autoComplete="email"
              onChange={handleTextChange}
              defaultValue={data.email}
            /> 
             <Typography component="h1" variant="h6">
              {t('signup_via_referral')}
            </Typography>
            <TextField
              className={isRTL ==="rtl"? classes.rootRtl_1:null}
              InputProps={{
                classes: {
                  notchedOutline: classes.notchedOutline
                }
              }}
              variant="outlined"
              margin="normal"
              fullWidth
              id="signupViaReferral"
              label={t('signup_via_referral')}
              name="signupViaReferral"
              autoComplete="signupViaReferral"
              onChange={handleTextChange}
              defaultValue={data.signupViaReferral}
            />
            </Grid>
            <Grid container>
          <Grid item xs={12} sm={12} md={6} lg={6}>
          <Button
              type="submit"
              width='45%'
              variant="contained"
              className={classes.submit}
              onClick = {()=>submitValue()}
            >
              {t('submit')}
            </Button>
          </Grid>
          </Grid>
            </Grid>
            {/* <AlertDialog open={settingsdata.error.flag && clicked} onClose={handleClose}>{t('update_failed')}</AlertDialog> */}
        </CardContent>
        </Box>

      
      </div>
  );
}